import { useScrollAnimation } from '../hooks/useScrollAnimation'

export default function MobileShowcase() {
  const ref = useScrollAnimation()

  return (
    <section className="bg-[#F0FDF4] section-padding border-t border-[#DCFCE7]">
      <div className="content-max">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div ref={ref}>
            <p className="text-xs font-medium tracking-widest uppercase text-[#1B5E20] mb-4">
              Native iOS & Android
            </p>
            <h2 className="font-display text-4xl lg:text-5xl text-[#0F172A] leading-tight mb-6">
              Your income stream, in your pocket
            </h2>
            <p className="text-base text-[#475569] leading-relaxed mb-8 max-w-md">
              The full Safe Dividend Tracker experience, optimized for mobile. Track dividends, view your calendar, and check your income reports — anywhere, anytime.
            </p>

            {/* Feature bullets */}
            <ul className="space-y-3 mb-8">
              {[
                'Dashboard with live portfolio metrics',
                'Dividend calendar with upcoming payments',
                'Income reports by month and year',
                'Portfolio management on the go',
                'Push notifications for dividend alerts',
              ].map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0">
                    <circle cx="9" cy="9" r="9" fill="#DCFCE7"/>
                    <path d="M5 9l3 3 5-5" stroke="#1B5E20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className="text-sm text-[#475569]">{item}</span>
                </li>
              ))}
            </ul>

            {/* Store buttons */}
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="https://apps.apple.com/app/id6761783631"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/badge-app-store.svg" alt="Download on the App Store"
                  style={{ height: 40, width: 'auto', display: 'block' }} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.safedividendtracker.app"
                target="_blank"
                rel="noopener noreferrer"
                style={{ overflow: 'hidden' }}
              >
                <img src="/badge-google-play.png" alt="Get it on Google Play"
                  style={{ height: 58, width: 'auto', display: 'block', marginTop: -9, marginBottom: -9 }} />
              </a>
            </div>
          </div>

          {/* Right: Phone mockups */}
          <div className="flex items-end justify-center gap-4 lg:gap-6">
            {/* Phone 1 - slightly raised */}
            <div className="flex-shrink-0 w-[180px] -mb-4 relative z-10">
              <div className="bg-[#1E293B] rounded-[32px] p-2 shadow-2xl" style={{transform: 'rotate(-3deg)'}}>
                <div className="bg-white rounded-[26px] overflow-hidden">
                  <img
                    src="/screenshots/app1.png"
                    alt="Mobile Dashboard"
                    className="w-full block"
                    style={{maxHeight: '360px', objectFit: 'cover', objectPosition: 'top'}}
                  />
                </div>
              </div>
            </div>
            {/* Phone 2 - main */}
            <div className="flex-shrink-0 w-[200px]">
              <div className="bg-[#1E293B] rounded-[32px] p-2 shadow-2xl" style={{transform: 'rotate(2deg)'}}>
                <div className="bg-white rounded-[26px] overflow-hidden">
                  <img
                    src="/screenshots/app2.png"
                    alt="Mobile Portfolio"
                    className="w-full block"
                    style={{maxHeight: '400px', objectFit: 'cover', objectPosition: 'top'}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
